import React from 'react';
import CTAButton from './CTAButton';
export function PricingSection() {
  return <section id="compra" className="py-6 px-4 bg-gradient-to-b from-green-50 to-white" data-id="element-189">
      <div className="max-w-4xl mx-auto" data-id="element-190">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-6" data-id="element-191">
          💰 VALOR REAL DEL PROGRAMA
        </h2>

        <div className="bg-white p-5 rounded-lg shadow-2xl mb-4" data-id="element-192">
          <div className="space-y-3 mb-4" data-id="element-193">
            <div className="flex justify-between items-center border-b pb-3" data-id="element-194">
              <span className="text-xl" data-id="element-195">6 Tomos completos</span>
              <span className="text-xl font-bold" data-id="element-196">$47000</span>
            </div>
            <div className="flex justify-between items-center border-b pb-3" data-id="element-197">
              <span className="text-xl" data-id="element-198">3 Bonos exclusivos</span>
              <span className="text-xl font-bold" data-id="element-199">$20000</span>
            </div>
            <div className="flex justify-between items-center border-b-2 border-black pb-3" data-id="element-200">
              <span className="text-2xl font-bold" data-id="element-201">💥 Total:</span>
              <span className="text-2xl font-bold line-through text-red-600" data-id="element-202">
                $67000
              </span>
            </div>
          </div>

          <div className="bg-gradient-to-r from-green-500 to-green-600 p-5 rounded-lg text-center mb-4" data-id="element-203">
            <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-204">
              🔥 HOY PUEDES ACCEDER POR:
            </p>
            <p className="text-5xl md:text-7xl font-black text-yellow-300 mb-1" data-id="element-205">
              $19990
            </p>
            <p className="text-xl text-white font-bold" data-id="element-206">
              ¡MÁS DE 70% DE DESCUENTO!
            </p>
          </div>

          <CTAButton text="¡SÍ! QUIERO ACCEDER AHORA POR $19,990" isCheckout data-id="element-207" />
        </div>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-208">
          <h3 className="text-2xl md:text-4xl font-black text-center mb-3" data-id="element-209">
            🚀 ESTO ES LO QUE PASA CUANDO COMPRAS
          </h3>
          <ul className="space-y-2" data-id="element-210">
            <li className="flex items-start" data-id="element-211">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-212">✔</span>
              <span className="text-xl" data-id="element-213">Acceso inmediato</span>
            </li>
            <li className="flex items-start" data-id="element-214">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-215">✔</span>
              <span className="text-xl" data-id="element-216">Todo listo para aplicar</span>
            </li>
            <li className="flex items-start" data-id="element-217">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-218">✔</span>
              <span className="text-xl" data-id="element-219">Material descargable</span>
            </li>
            <li className="flex items-start" data-id="element-220">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-221">✔</span>
              <span className="text-xl" data-id="element-222">Uso ilimitado</span>
            </li>
          </ul>
        </div>

        <div className="bg-red-50 p-5 rounded-lg shadow-lg border-4 border-red-500" data-id="element-223">
          <h3 className="text-2xl md:text-4xl font-black text-red-600 text-center mb-2" data-id="element-224">
            ⏳ IMPORTANTE
          </h3>
          <p className="text-xl text-center mb-2" data-id="element-225">Este precio es promocional</p>
          <p className="text-xl text-center font-bold" data-id="element-226">
            y puede cambiar en cualquier momento.
          </p>
        </div>
      </div>
    </section>;
}
export default PricingSection;